import ImageLayer from "ol/layer/Image";
import { ImageWMS, Vector } from "ol/source";
import VectorLayer from "ol/layer/Vector";
//funcion fetchfeatureinfo
//busca la tabla de atributos y la transforma para el popup
const fetchFeatureInfo1 = async (layer, coordinate, viewResolution) => {
  const source = layer.getSource();
  let layerInfo = "";

  if (source instanceof ImageWMS) {
    const url = source.getFeatureInfoUrl(
      coordinate,
      viewResolution,
      "EPSG:3857",
      { INFO_FORMAT: "application/json" }
    );

    if (url) {
      const response = await fetch(url);
      const json1 = await response.json();

      if (json1.features && json1.features.length > 0) {
        const properties = json1.features[0].properties;
        const titulo = layer.get("title");

        let info = `<h4><b> &#128204; ${titulo}</b></h4>`;
        for (const key in properties) {
          info += `<p><b>${key}:</b> ${properties[key]}</p>`;
        }

        layerInfo += info;
      }
    }
  }

  return layerInfo;
};

const featureJson = async (feature, layer, coordinate, viewResolution) => {
  let layerInfo = "";
  //obtener el name del vector layer?
  let info = `<h4><b> &#128204; ${layer.get("title")}</b></h4>`;
  const properties = feature.getKeys();
  //except geomery
  //console.log(feature.get('geometry'))
  //geostyler?
  for (const key in properties) {
    //except geomery
    info += `<p><b>${properties[key]}:</b> ${feature.get(properties[key])}</p>`;
  }

  return (layerInfo += info);
};

export const popUP = async (evt, map, popup) => {
  const viewResolution = map.getView().getResolution();
  let allLayerInfo = "";

  //traer solo las activas?¿
  let layers = map.getAllLayers();
  layers = layers.filter((layer) => layer.getVisible());
  const layerInfoPromises = [];

  for (const layer of layers) {
    if (layer instanceof ImageLayer) {
      layerInfoPromises.push(
        fetchFeatureInfo1(layer, evt.coordinate, viewResolution)
      );
    }

    //porjson
    // if (layer instanceof VectorLayer) {
    //   const feature = map.forEachFeatureAtPixel(evt.pixel, function (feature) {
    //     return feature;
    //   });
    //   layerInfoPromises.push(
    //     featureJson(feature, layer, evt.coordinate, viewResolution)
    //   );
    // }
  }

  try {
    const layerInfos = await Promise.all(layerInfoPromises);
    allLayerInfo = layerInfos.join("");
    if (allLayerInfo) {
      popup.show(evt.coordinate, `<div>${allLayerInfo}</div>`);
    } else {
      popup.hide();
    }
  } catch (error) {
    console.error("Error fetching layer info:", error);
    popup.hide(); // Hide popup
  }
};
